import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PromoStatusService } from '../services/promo-status.service';
import { switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';

export const promoStatusGuard: CanActivateFn = (route, state) => {
	const promoStatusService = inject(PromoStatusService);
	const router = inject(Router);

	// Check if promo status is already loaded
	if (!promoStatusService.isLoading()) {
		// Status is already loaded, check immediately
		if (promoStatusService.isPromoActive()) {
			return true;
		} else {
			return router.createUrlTree(['/promo-not-active']);
		}
	}

	// Status is still loading, wait for it to complete
	return from(promoStatusService.loadPromoConfig()).pipe(
		switchMap(() => {
			if (promoStatusService.isPromoActive()) {
				return of(true);
			} else {
				return of(router.createUrlTree(['/promo-not-active']));
			}
		})
	);
};
